export default __webpack_public_path__ + "static/media/GLMR.25cac67c.png";